import React from 'react';
import { Award, Shield, Users, Sparkles } from 'lucide-react';
import Card from '../ui/Card';

const About = () => {
  const features = [
    {
      icon: Award,
      title: '1+ Years Experience',
      description: 'Proven track record of delivering exceptional car care services',
    },
    {
      icon: Shield,
      title: 'Premium Products',
      description: 'Professional-grade cleaning products for superior results',
    },
    {
      icon: Users,
      title: 'Trained Technicians',
      description: 'Certified and experienced team dedicated to excellence',
    },
    {
      icon: Sparkles,
      title: 'Mobile Convenience',
      description: 'We come to you - home, office, or anywhere you need',
    },
  ];

  return (
    <section className="section section-white">
      <div className="container">
        <div className="grid grid-2 gap-xl items-center">
          <div>
            <div className="badge">About Us</div>
            <h2>Premium Car Care, Wherever You Are</h2>
            <p style={{fontSize: '1.125rem', color: 'var(--gray-600)', marginBottom: '1.5rem', lineHeight: '1.7'}}>
              ARA Mobile Valeting brings professional car care directly to your location. 
              With over 5 years of experience, we've perfected the art of mobile valeting, 
              combining premium products, expert techniques, and unmatched convenience.
            </p>
            <p style={{fontSize: '1.125rem', color: 'var(--gray-600)', marginBottom: '2rem', lineHeight: '1.7'}}>
              Whether it's your home, office, or any location across Greater London and 
              surrounding areas, our trained technicians deliver showroom-quality results 
              without you having to leave.
            </p>

            <div className="grid grid-3" style={{gap: '1rem'}}>
              <div className="text-center">
                <div className="stat-number">100+</div>
                <div className="stat-label">Cars Valeted</div>
              </div>
              <div className="text-center">
                <div className="stat-number">100+</div>
                <div className="stat-label">Happy Clients</div>
              </div>
              <div className="text-center">
                <div className="stat-number">4.9★</div>
                <div className="stat-label">Rating</div>
              </div>
            </div>
          </div>

          <div className="grid grid-2 gap-lg">
            {features.map((feature, index) => (
              <Card key={index} hover style={{padding: '1.5rem'}}>
                <div className="value-icon" style={{width: '48px', height: '48px', marginBottom: '1rem', marginLeft: '1rem', marginTop: '1rem'}}>
                  <feature.icon size={24} />
                </div>
                <h3 style={{fontSize: '1.125rem', marginBottom: '0.5rem', marginLeft: '1rem'}}>{feature.title}</h3>
                <p style={{fontSize: '0.875rem', color: 'var(--gray-600)', marginLeft: '1rem'}}>{feature.description}</p>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;